import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { UnRx } from '@pebula/utils';
import { timer } from 'rxjs';

@UnRx()
@Component({
  selector: 'sg-copy-button',
  templateUrl: './sg-copy-button.component.html',
  styleUrls: ['./sg-copy-button.component.scss'],
  standalone: false,
})
export class SgCopyButtonComponent {
  private cdr = inject(ChangeDetectorRef);
  @Input() valueToCopy: string;
  @Input() showTooltip: boolean = true;
  @Input() tooltipDuration: number = 1500; // Duration in milliseconds
  @Input() successMessage: string = 'Copied!';
  @Input() errorMessage: string = 'Failed to copy';
  @Output() afterCopy = new EventEmitter<boolean>();

  tooltipMessage = '';
  isTooltipVisible = false;

  onCopy(): void {
    if (this.valueToCopy) {
      navigator.clipboard.writeText(this.valueToCopy).then(
        () => {
          this.afterCopy.emit(true);
          if (this.showTooltip) {
            this.showTooltipMessage(this.successMessage);
          }
        },
        (err) => {
          this.afterCopy.emit(false);
          if (this.showTooltip) {
            this.showTooltipMessage(this.errorMessage);
          }
        }
      );
    } else {
      console.warn('No value to copy');
    }
  }

  private showTooltipMessage(message: string): void {
    this.tooltipMessage = message;
    this.isTooltipVisible = true;

    timer(this.tooltipDuration)
      .pipe(UnRx(this))
      .subscribe(() => {
        this.isTooltipVisible = false;
        this.cdr.markForCheck();
      });
  }
}
